import { FaCircleCheck } from "react-icons/fa6"
import { IoWarning } from "react-icons/io5"
import { useNavigate } from "react-router-dom"
import { Box, Center, VStack } from "@chakra-ui/react"
import { Button, Text } from "@/components"
import { useViewer } from "@/contexts"

interface Props {
  complianceType: string
  showWarning?: boolean
  onNavigateToDocuments?: () => void
}

export const PendingDocumentComponent = ({ complianceType, showWarning, onNavigateToDocuments }: Props) => {
  const navigate = useNavigate()
  const { viewedClient } = useViewer()

  const handleGoToDocuments = () => {
    if (onNavigateToDocuments) {
      onNavigateToDocuments()
    } else {
      navigate(viewedClient ? `/clients/${viewedClient.id}` : "/documents")
    }
  }

  return (
    <Center w="100%" h="100%">
      <VStack position="relative" zIndex={1} w={{ base: "92%", md: "40%" }} p={5} borderRadius={10} bg="white" boxShadow="md" mt={20} >
        <Box borderRadius={5} bg={showWarning ? "yellow.400" : "green.300"} p={3}>
          {showWarning ? <IoWarning size={30} color="white" /> : <FaCircleCheck size={30} color="white" />}
        </Box>
        <Text fontSize="lg" fontWeight="bold" textAlign="center" mt={2} mb={2}>
          {showWarning ? "Action Required" : "Thank You!"}
        </Text>
        <Text fontSize="sm" textAlign="center">
          {showWarning
            ? `You still need to sign the ${complianceType} DocuSign email sent to your email address. Please check your email for a DocuSign link sent from docusign@esofund.com.`
            : `Thank you for signing our ${complianceType}. Please check your email for a DocuSign link sent from docusign@esofund.com which you and your Equity Partner will sign.`
          }
        </Text>
        <Text fontSize="sm" textAlign="center" mt={5}>If you didn't receive an email please contact your Equity Partner.</Text>
        <Text fontSize="sm" textAlign="center" mt={5}>
          In the meantime, you can go to the documents page to upload any files you still need to upload.
          If you have any questions, feel free to email or schedule a call with your equity partner!
        </Text>
        <Button variant="solid" onClick={handleGoToDocuments}>
          Proceed to Documents
        </Button>
      </VStack>
    </Center>
  )
}
